import React from 'react';
import PropTypes from 'prop-types';
import cancelEvent from '../../../services/mini/cancelEvent';

class FilterLabel extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.onClick = this.onClick.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
    }

    onClick(e) {
        cancelEvent(e);
    }

    resetFilter() {
        const {
            entity,
            onReset
        } = this.props;

        if (entity) {
            onReset(entity);
        } else {
            onReset();
        }
    }

    render() {
        const {
            title
        } = this.props;

        return <div className={`filter-label `} onClick={this.onClick}>
            {title}
            <i className="icon icon-alan-remove-fat" onClick={this.resetFilter} />
        </div>;
    }
}

FilterLabel.propTypes = {
    entity: PropTypes.object,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    onReset: PropTypes.func.isRequired,
};

export default FilterLabel;